import React, { cloneElement, isValidElement, ReactNode, useState } from "react";
import styled from "styled-components";
import { AccordionItem, AccordionItemProps } from "./AccordionItem";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  max-height: inherit;
`;

type Props = {
  id: string;
  defaultExpandedIndex?: number;
  children: ReactNode;
};

export const Accordion: React.FC<Props> = ({ id, defaultExpandedIndex = 0, children }) => {
  const [expandedIndex, setExpandedIndex] = useState<number | undefined>(defaultExpandedIndex);

  const childrenWithProps = React.Children.map(children, (child, index) => {
    const props = {
      parentId: id,
      index,
      isExpanded: index === expandedIndex,
      setExpandedIndex,
    };
    if (isValidElement(child)) {
      if (child.type !== AccordionItem) {
        throw new Error("All Accordion children should be of type `AccordionItem`.");
      }

      return cloneElement<AccordionItemProps>(child as any, props);
    }
  });

  return <Container id={id}>{childrenWithProps}</Container>;
};
